// src/utils/firebaseErrorMessages.js

export const SUSPENDED_ACCOUNT_MESSAGE =
  "Your network's access to School Explorer is no longer active. Please contact support@educationdatacollective.com to learn about licensing options and restore access.";

const getFirebaseErrorMessage = (errorCode) => {
    switch (errorCode) {
      case 'auth/invalid-email':
        return 'Please enter a valid email address.';
      case 'auth/user-disabled':
        return SUSPENDED_ACCOUNT_MESSAGE;
      case 'auth/user-not-found':
        return 'No account found with this email. Please check your email or register.';
      case 'auth/invalid-credential':
        return 'Incorrect username or password. Please try again or reset password.';
      case 'auth/email-already-in-use':
        return 'An account with this email already exists.';
      case 'auth/weak-password':
        return 'Password is too weak. Please use a stronger password.';
      default:
        return 'An error occurred. Please try again.';
    }
  };
  
  export default getFirebaseErrorMessage;